import { Component, effect } from '@angular/core';
import { ActivatedRoute, NavigationEnd,  RouterModule, Router, RouterOutlet } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { filter } from 'rxjs';
import { MenubarModule } from 'primeng/menubar';
import { OfficeTemplatesService } from './office-templates/services/office-templates.service';
import { Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { CategoriesService } from '@/services/api/categories.service';
import { OfficesService } from '@/services/api/franchises.service';
import { PlansService } from '@/services/api/plans.service';
import { TabsModule } from 'primeng/tabs';

interface tabMenuItem extends MenuItem {
  value: number;
}

@Component({
    selector: 'app-assemblies',
    imports: [RouterOutlet, CommonModule, MenubarModule, TabsModule, RouterModule],
    template: `
  <div class="w-full card p-3 border-round">
    <p-tabs value="assemblies">
    <p-tablist>
        @for(tab of tabs; track tab.route){
            <p-tab [value]="tab.route" [routerLink]="tab.route" class="flex items-center !gap-2 text-inherit">
                <i [class]="tab.icon"></i>
                <span>{{ tab.label }}</span>
            </p-tab>
        }
    </p-tablist>
</p-tabs>

    <router-outlet></router-outlet>
  </div>
  `
})
export class AssembliesOperationsComponent {

  tabs = [
    { route: 'assemblies', label: 'Assemblies', icon: 'pi pi-home' },
    { route: 'officetemplates', label: 'Office Templates', icon: 'pi pi-chart-line' }
];

  constructor(
    public categoriesService: CategoriesService,
    public officeService: OfficesService,
    public officeTemplatesService: OfficeTemplatesService,
    private router: Router,
    private route: ActivatedRoute,
    public plansService: PlansService,
    private titleService: Title
  ) { 
    if(this.plansService.allPlansData().length === 0) {
      this.plansService.populatePlans();
  }
    if(this.officeTemplatesService.opsTemplates().length === 0) {
      this.officeTemplatesService.getOpsTemplates();
    }
    this.categoriesService.loadCategories();
    // effect(() => {
    //   const currentRoute = this.route.firstChild?.snapshot.url[0]?.path;
    //   this.activeItem = this.items.find(item => item.routerLink === currentRoute) || this.items[0];
    // });
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const currentRoute = this.route.firstChild?.snapshot.url[0]?.path;
    });
    
  }

}
